import { APP_INITIALIZER, NgModule, Pipe, PipeTransform } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NavbarModule } from '@huge-monorepo/portal/modules';
import { LayoutComponent } from '@huge-monorepo/portal/layout';
import { LayoutModule } from '@angular/cdk/layout';
import { CoreModule } from '@huge-monorepo/portal/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from '@huge-monorepo/portal/services';
import { TimeAgoPipe } from 'time-ago-pipe';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { SplashPageModule } from '@huge-monorepo/portal/modules';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToolsModule } from '@huge-monorepo/portal/modules';
import { DomainRoles, Domains } from '@huge-monorepo/portal/models';
import * as Sentry from '@sentry/angular-ivy';
import { ToastrModule } from 'ngx-toastr';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { environment } from '../environments/environment';
import { Environment } from '@huge-monorepo/portal/config';

@Pipe({
  name: 'timeAgo',
  pure: false,
})
export class TimeAgoExtendsPipe extends TimeAgoPipe implements PipeTransform {}

@NgModule({
  declarations: [AppComponent, LayoutComponent, TimeAgoExtendsPipe],
  exports: [TimeAgoExtendsPipe],
  imports: [
    BrowserModule,
    InfiniteScrollModule,
    CoreModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    LayoutModule,
    NavbarModule,
    AppRoutingModule,
    RouterModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SplashPageModule,
    ToolsModule,
    ToastrModule.forRoot(),
    NgxSkeletonLoaderModule,
  ],
  providers: [
    { provide: 'WINDOW', useFactory: getWindow },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: Environment,
      useValue: environment,
    },
    TimeAgoExtendsPipe,
    Domains,
    DomainRoles,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function getWindow() {
  return typeof window !== 'undefined' ? window : null;
}
